import FormService from '../../services/FormService';

export default {
    name: "buses_create_component",

    data() {
        return {
            buses: [],
            transporters: [],
            drivers: [],
            bus_models: [],
            form: new FormService({
                transporter_id: '',
                bus_model_id: '',
                driver_id: '',
                bus_number: '',
            }),
            test: null,
            id: null
        }
    },

    mounted() {
    },

    created() {
        this.id = this.$route.params.id;

        this.$api.get('buses.relations')
            .then(response => {
                this.transporters = response.data.transporters;
                this.drivers = response.data.drivers;
                this.bus_models = response.data.model;
            });

        if (this.id > 0) {
            this.$api.get('buses.show', this.id)
                .then(({data}) => {
                    this.form.setData(data);
                })
        }
    },

    methods: {

        save() {
            this.isSending = true;
            if (this.id > 0) {
                this.update();
            } else {
                this.store();
            }
        },
        store() {
            this.form.post('buses.store')
                .then(res => {
                    if (!res.errors) {
                        this.$router.push('/buses/index');
                        this.$store.commit('successNotify');
                    }
                })
        },
        update() {
            this.form.put('buses.update', this.id)
                .then(res => {
                    if (!res.errors) {
                        this.$router.push('/buses/index');
                        this.$store.commit('successNotify');
                    }
                })
        }
    },


}
